// extracted by mini-css-extract-plugin
export default {"container_modal":"ModalUsuarioInfo_container_modal__MvZmo","topbar_item":"ModalUsuarioInfo_topbar_item__9thaV","texto_link":"ModalUsuarioInfo_texto_link__k-3Or"};